module.exports = __webpack_public_path__ + "img/dhfesta_logo_eng_1.555ba5b1.png";